// Module
var code = "<div ref=\"name\"></div>\n<div ref=\"digitCodeContainer\">\n\n</div>";
// Exports
module.exports = code;